$(function () {
  $(document).on('click', e => {
    if ( !$('.js-rating-feedback-open-info').is(e.target) && $('.js-rating-feedback-hint').has(e.target).length === 0 ) {
      $('.js-rating-feedback-hint').removeClass('active')
    }
  })

  $(document).on('click', '.js-rating-feedback-open-info', function (e) {
    e.preventDefault();
    const $container = $(this).parents('.js-rating-feedback')
    const $hintContainer = $container.find('.js-rating-feedback-hint')

    $hintContainer.toggleClass('active')
  })

})